import React from "react";

const SvgTwitter = props => (
  <svg viewBox="10 -6 28 24" {...props}>
    <path d="M29-5H29.8c1.3.1 2.5.6 3.5 1.5.2.2.4.2.7.2 1-.3 2-.6 2.9-1.1.1 0 .2-.1.3-.1-.4 1.3-1.2 2.3-2.3 3.1 1-.1 2-.4 3-.7-.2.3-.5.7-.7.9C36.6-.6 36 0 35.4.5c-.1.1-.2.3-.2.5 0 1.1-.1 2.2-.3 3.3-.2 1.4-.6 2.8-1.2 4.1-.9 2-2.2 3.7-3.8 5.2-1.9 1.5-3.9 2.7-6.3 3.4-1.1.3-2.2.5-3.4.6-.3 0-.5 0-.8.1h-1.2-.1c-1.4-.1-2.9-.3-4.2-.8-1.1-.4-2.1-.8-3.1-1.4-.2-.1-.4-.3-.6-.4 1.5.1 2.9 0 4.4-.4 1.4-.4 2.7-1.1 3.9-2-3-.3-4.6-2.1-5.3-4 .8.1 1.6.1 2.4-.1-1.3-.4-2.4-1-3.2-2-.8-1.1-1.3-2.2-1.2-3.6.4.2.8.3 1.2.4.4.1.8.2 1.3.2v-.1c-1.2-.9-2-2-2.3-3.5-.4-1.3-.2-2.6.6-4 3.1 3.6 7 5.6 11.8 6v-.2c-.1-.7-.1-1.4 0-2.1.4-2.3 2.1-4.1 4.4-4.6.2-.1.5-.1.8-.1z" />
  </svg>
);

export default SvgTwitter;
